import { getDeviceStore } from '../stores/device_store';
import { useObserver } from 'mobx-react';

export const useVideoDevices = (): {
    videoDevices: MediaDeviceInfo[];
    hasVideoPermission: boolean;
} => {
    const devices = useObserver(() => getDeviceStore()?.videoDevices);
    const hasVideoPermission = useObserver(() => getDeviceStore()?.hasVideoPermission);

    return { videoDevices: devices, hasVideoPermission };
};

export const useAudioDevices = (): {
    audioInputDevices: MediaDeviceInfo[];
    audioOutputDevices: MediaDeviceInfo[];
    hasAudioPermission: boolean;
} => {
    const inputDevices = useObserver(() => getDeviceStore()?.audioInputDevices);
    const outputDevices = useObserver(() => getDeviceStore()?.audioOutputDevices);
    const hasAudioPermission = useObserver(() => getDeviceStore()?.hasAudioPermission);

    return {
        audioInputDevices: inputDevices,
        audioOutputDevices: outputDevices,
        hasAudioPermission,
    };
};
